// import store from '@/store';
// import moment from "moment";
import consts from "@/consts";
import {liteTemplate} from "@/lib/routes";

const defaultSetRoute = {
    geozone: (route, router) => {
        if(route.meta?.mainRouteName !== consts.routerNames.geoitems.main) {
            if(consts.app.$isDevelopment) console.warn('geozone', route);
            return false
        }
        router.push({
            name: consts.routerNames.geoitems.main,
            params: {},
            query: {...route.query},
        })
    },
    geozoneId: (route, router, geozoneId) => {
        if(route.meta?.mainRouteName !== consts.routerNames.geoitems.main) {
            if(consts.app.$isDevelopment) console.warn('geozoneId', route);
            return false
        }
        router.push({
            name: consts.routerNames.geoitems.id,
            params: {
                geozoneId,
            },
            query: {...route.query},
        })
    },
    geozoneFilter: (route, router, filter) => {
        if(route.meta?.mainRouteName !== consts.routerNames.geoitems.main) {
            if(consts.app.$isDevelopment) console.warn('geozoneFilter', route);
            return false
        }
        let geozoneId = route.params?.geozoneId
        router.push({
            name: consts.routerNames.geoitems.main,
            params: {
                geozoneId,
            },
            query: {
                name: filter.name || undefined
            },
        })
    },
    geozoneEdit: (route, router, geozoneId) => {
        if(route.meta?.mainRouteName !== consts.routerNames.geoitems.main) {
            if(consts.app.$isDevelopment) console.warn('geozoneEdit', route);
            return false
        }
        router.push({
            name: consts.routerNames.geoitems.edit.main,
            params: {
                geozoneId,
            },
            query: {...route.query},
        })
    },
    returnToParent:(route, router) => {
        if(route.meta?.mainRouteName !== consts.routerNames.geoitems.main) {
            if(consts.app.$isDevelopment) console.warn(consts.routerNames.geoitems.main+' returnToParent', route);
            return false;
        }
        let geozoneId = route.params.geozoneId > 0
        let name = geozoneId ? route.meta?.parentRouteName : consts.routerNames.geoitems.main;
        router.push({
            name: name,
            params: {
                ...route.params,
            },
            query: {...route.query}
        })
    },
    liteTemplate,
}

const routes = (process.env.VUE_APP_PACKAGE !== 'intuit.portal') ? [] : [
    {
        path: 'geoitems/:pathMatch(.*)?/:noList(no-list)?',
        name: consts.routerNames.geoitems.main,
        meta: {
            list: 'GeoitemsList',
            mainRouteName: consts.routerNames.geoitems.main,
            showMap: true,
            isLimited: false,
            //unitTracking: true,
            layers: {
                ...consts.defaultSettingsLayers,
                units: {visible: false, showInList: true, showLayer: true},
                geoitems: {visible: true, showInList: true, showLayer: true},
            },
            setRoute: defaultSetRoute,
        },
        component:() => import('@/views/intuit/portal/GeoitemsPage.vue'),
        children: [
            {
                path: ':geozoneId(\\d+)',
                name: consts.routerNames.geoitems.id,
                meta:{
                    mainRouteName: consts.routerNames.geoitems.main,
                    parentRouteName: consts.routerNames.geoitems.main,
                },
                children: [
                    {
                        path: 'edit',
                        name: consts.routerNames.geoitems.edit.main,
                        meta: {
                            mainRouteName: consts.routerNames.geoitems.main,
                            parentRouteName: consts.routerNames.geoitems.id,
                            blockingRoutesTransitionFromOutside: true,
                            sectionInfoByRoute: true,
                            layers: {
                                ...consts.defaultSettingsLayers,
                                units: {visible: false, showInList: true, showLayer: true},
                                geoitems: {visible: false, showInList: true, showLayer: true},
                                geoitem_edit: {visible: true, showInList: false, showLayer: true},
                            }
                        },
                        props: {
                            sectionInfoByRoute: (route) => ({
                                geozoneId: +route.params.geozoneId,
                                time: Date.now(),
                            })
                        },
                        components: {
                            sectionInfoByRoute: () => import('@/components/geoitems/sectionInfo/GeozoneEdit.vue'),
                        }
                    },
                ]
            },
        ],
    },
];

export default routes